import React from 'react'
import './style.css'

function ImportTamanhoInfoStep2() {
  return (
    <div className='ImportTamanhoInfoStep2'>
        <p>Você está na primeira etapa do assistente de importação. </p>

        <p>Vamos te orientar no Importação dos <b>TAMANHOS</b>.</p>

        <p><b>Atenção:</b> Caracteres estranhos nas descrição do tamanho serão removidos.</p>

        <p>Nesta tela você deve indicar o arquivo .CSV que contem as categorias relacionadas aos seus produtos.</p>
    </div>
  )
}

export default ImportTamanhoInfoStep2;